/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Reznak (reznak@cadwork.cz)
 */

/**
 * Simple manipulator manager only for environment
 *
 * @constructor
 */

export default
class ManipulatorManager {
    private _freeID: number = 1;

    constructor() {}

    /**
     * Get free id and reserve "count" of ids
     *
     * @param {number} count
     * @return {number}
     */
    public getID(count: number): number {
        let tmp = this._freeID;
        this._freeID += count;
        return tmp;
    }
}

